import { createBrowserRouter, Navigate } from 'react-router-dom'
import AppLayout from '@/app/shell/AppLayout'
import RequirePermission from '@/app/router/RequirePermission'
import DashboardPage from '@/pages/dashboard/DashboardPage'
import MessageListPage from '@/pages/messages/MessageListPage'
import DraftListPage from '@/pages/drafts/DraftListPage'
import DraftReviewPage from '@/pages/drafts/DraftReviewPage'
import TicketListPage from '@/pages/tickets/TicketListPage'
import TicketDetailPage from '@/pages/tickets/TicketDetailPage'
import SlaEventListPage from '@/pages/sla/SlaEventListPage'
import SlaRuleManagementPage from '@/pages/sla/SlaRuleManagementPage'
import WorkflowTracePage from '@/pages/workflowTraces/WorkflowTracePage'
import KnowledgeListPage from '@/pages/knowledge/KnowledgeListPage'
import JobRunsPage from '@/pages/system/JobRunsPage'
import GroupBindingListPage from '@/pages/groupBindings/GroupBindingListPage'
import UserManagementPage from '@/pages/users/UserManagementPage'
import ReceptionShareManagementPage from '@/pages/system/ReceptionShareManagementPage'
import AdminManualPage from '@/pages/manual/AdminManualPage'
import ReceptionManualPage from '@/pages/manual/ReceptionManualPage'
import LoginPage from '@/pages/auth/LoginPage'
import PasswordChangePage from '@/pages/account/PasswordChangePage'
import AfterSalesPage from '@/pages/afterSales/AfterSalesPage'

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    path: '/',
    element: <AppLayout />,
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: 'dashboard', element: <DashboardPage /> },
      { path: 'after-sales', element: <AfterSalesPage /> },
      {
        path: 'messages',
        element: (
          <RequirePermission permission="message:read">
            <MessageListPage />
          </RequirePermission>
        ),
      },
      {
        path: 'drafts',
        element: (
          <RequirePermission permission="draft:read">
            <DraftListPage />
          </RequirePermission>
        ),
      },
      {
        path: 'drafts/:draftId',
        element: (
          <RequirePermission permission="draft:read">
            <DraftReviewPage />
          </RequirePermission>
        ),
      },
      {
        path: 'tickets',
        element: (
          <RequirePermission permission="ticket:read">
            <TicketListPage />
          </RequirePermission>
        ),
      },
      {
        path: 'tickets/:mappingId',
        element: (
          <RequirePermission permission="ticket:read">
            <TicketDetailPage />
          </RequirePermission>
        ),
      },
      {
        path: 'sla',
        element: (
          <RequirePermission permission="sla:read">
            <SlaEventListPage />
          </RequirePermission>
        ),
      },
      {
        path: 'sla/rules',
        element: (
          <RequirePermission permission="user:manage" role="admin">
            <SlaRuleManagementPage />
          </RequirePermission>
        ),
      },
      {
        path: 'workflow-traces/:entryType/:entryId',
        element: (
          <RequirePermission permission="sla:read">
            <WorkflowTracePage />
          </RequirePermission>
        ),
      },
      {
        path: 'group-bindings',
        element: (
          <RequirePermission permission="binding:read">
            <GroupBindingListPage />
          </RequirePermission>
        ),
      },
      { path: 'knowledge', element: <KnowledgeListPage /> },
      {
        path: 'manual/reception',
        element: (
          <RequirePermission permission="message:read">
            <ReceptionManualPage />
          </RequirePermission>
        ),
      },
      {
        path: 'manual/admin',
        element: (
          <RequirePermission permission="user:manage">
            <AdminManualPage />
          </RequirePermission>
        ),
      },
      { path: 'account/password', element: <PasswordChangePage /> },
      {
        path: 'system/reception-shares',
        element: (
          <RequirePermission permission="reception_share:manage" role="admin">
            <ReceptionShareManagementPage />
          </RequirePermission>
        ),
      },
      {
        path: 'system/users',
        element: (
          <RequirePermission permission="user:manage">
            <UserManagementPage />
          </RequirePermission>
        ),
      },
      {
        path: 'system/job-runs',
        element: (
          <RequirePermission permission="system:health_read">
            <JobRunsPage />
          </RequirePermission>
        ),
      },
    ],
  },
])
